import React, { useState } from 'react';
import { ViewRoleSkeleton } from './view-role.skeleton';
import styles from './view-role.module.css';
import { IViewRoleLayoutProps } from './view-role.models';
import { PageLoaderLayer } from '../../../components/loading-handling/loader-layers/page-loader-layer/page-loader-layer';
import { PagePath } from '../../../navigation/navigation.enums';
import ViewRoleSkillsWidget from './view-role-skills/view-role-skills.widget';
import { AddTwoToneIcon, Button, colourString, DropdownSearch, MapIcon, Modal, PageHeader } from '@keplerco/core';
import { CardButton } from './view-role.styles';
import { DefaultOptions, useApis } from '../../../global-state';
import { useNavigate } from 'react-router-dom';
import { relative } from 'path';

export function ViewRoleLayout({ role }: IViewRoleLayoutProps) {
  const navigate = useNavigate();
  const { userRoleApi } = useApis();
  const [isDirty, setIsDirty] = useState<boolean>(false);
  let a = role?.name?.toLocaleLowerCase()?.startsWith('a') ? 'an' : 'a';
  const [chosenRole, setChosenRole] = useState<boolean>(false);
  const [selectedDesignation, setDesignation] = useState<string>();
  return (
    <PageLoaderLayer path={PagePath.role} skeletonLoader={<ViewRoleSkeleton />}>
      <div className="pageWrapper wrapper">
        {!!role && (
          <div className={styles.viewRoleBody}>
            <PageHeader
              breadcrumbs={[
                {
                  name: 'Roles',
                  url: PagePath.roles,
                },
                {
                  name: role.name!,
                  url: window.location.pathname,
                },
              ]}
              title={role.name}
              subtitle={role.description}
            />
            {!role.chosenDesignationId &&
              <CardButton type="button" onClick={() => setChosenRole(true)}>
                <AddTwoToneIcon primaryTone="default" secondaryTone="default" />
                &nbsp;&nbsp;
                <h5 className="heading5" style={{ color: colourString('default') }}>
                  Choose {role.name} for your career.
                </h5>
              </CardButton>
            }

            {!!role.chosenDesignationId &&
              <CardButton className="green" type="button" onClick={() => navigate(PagePath.skills)}>
                <MapIcon />
                &nbsp;&nbsp;
                <h5 className="heading5" style={{ color: colourString('default') }}>
                  You are {a} {role.name}. Go to skills
                </h5>
              </CardButton>}
            <ViewRoleSkillsWidget role={role} />
          </div>
        )}
      </div>
      <Modal open={chosenRole} onClose={() => setChosenRole(false)}>
        <div className="dialogContentLayout modalContentLayout">
          <header className="dialogHeaderLayout modalHeaderLayout">
            <h2 className="heading2">Are you sure you would like to choose {role?.name}?</h2>
          </header>
          <div className="dialogBodyLayout">
            <h6 className="subtitle">Please select your designation:</h6>
          </div>
          {!!role?.designations && (
            <DropdownSearch
              label="Designation"
              items={role.designations.map(designation => ({
                value: designation.id!,
                label: designation.name!,
                onClick: () => {
                  setDesignation(designation.id);
                },
                selected: selectedDesignation === designation.id,
              }))
              }
              validation={{
                dirty: isDirty,
                invalid: !selectedDesignation,
                message: 'Please select a designation',
              }}
            />)}
          <footer className="dialogFooterLayout modalFooterLayout">
            <Button filled type="button" onClick={async () => {
              setIsDirty(true);
              if (!!selectedDesignation) {
                await userRoleApi.userRolePost(role?.id, selectedDesignation, DefaultOptions);
                setChosenRole(false);
                role!.chosenDesignationId = selectedDesignation;
              }
            }}>
              CONFIRM
            </Button>
          </footer>
        </div>
      </Modal>
    </PageLoaderLayer>
  );
}
